import { render, staticRenderFns } from "./teacherExam_desktop.vue?vue&type=template&id=0c16ceaa&scoped=true&"
import script from "./teacherExam_desktop.vue?vue&type=script&lang=js&"
export * from "./teacherExam_desktop.vue?vue&type=script&lang=js&"
import style0 from "./teacherExam_desktop.vue?vue&type=style&index=0&id=0c16ceaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c16ceaa",
  null
  
)

export default component.exports